function checkFullwidth(value = "") {
    const arr = value.split("");
    arr.forEach(ele => {
        if (eaw.length(ele) !== 1) {
            throw "fullwidth"
        }
    })
    return true;
}

module.exports = {checkFullwidth}
